import { Link } from "react-router-dom";
import type { TitleItem } from "@/types/content";

interface TitleCardProps {
  item: TitleItem;
  compact?: boolean;
}

export default function TitleCard({ item, compact = false }: TitleCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className={`relative w-full ${compact ? "aspect-[3/4]" : "aspect-[3/4]"} overflow-hidden bg-primary-900`}>
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} ${item.genres[0]} 奇优影院`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        <span className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-[11px] font-label bg-background-50/95 text-primary-800">
          {item.type === "movie" ? "电影" : "剧集"}
        </span>
        <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-[11px] font-label bg-secondary-400 text-foreground-950">
          热度 {item.hot}
        </span>
        <span className="absolute bottom-2 right-2 w-7 h-7 rounded-full bg-background-50/90 flex items-center justify-center opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all">
          <i className="ri-play-fill text-primary-700 text-sm w-4 h-4 flex items-center justify-center" />
        </span>
      </div>
      <div className="p-2.5 md:p-3">
        <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-accent-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">
          {item.year} · {item.region}
          {item.type === "tv" && item.episodeCount ? ` · 全${item.episodeCount}集` : ""}
        </p>
        <div className="flex flex-wrap gap-1 mt-1.5">
          {item.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] font-label"
            >
              {genre}
            </span>
          ))}
        </div>
        {item.type === "tv" && item.cast.length > 0 && (
          <p className="text-[11px] text-foreground-400 mt-1 truncate">主演：{item.cast.slice(0, 2).join(" / ")}</p>
        )}
      </div>
    </Link>
  );
}